import React from 'react';
import { CaptureOverlay } from '../shared';

interface PhotoReviewProps {
  taskName: string;
  photos: string[];
  onDeletePhoto: (index: number) => void;
  onPhotoTap: (index: number) => void;
  onAddMore: () => void;
  onContinue: () => void;
  onClose: () => void;
}

export const PhotoReview: React.FC<PhotoReviewProps> = ({
  taskName,
  photos,
  onDeletePhoto,
  onPhotoTap,
  onAddMore,
  onContinue,
  onClose,
}) => {
  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className="co-sheet">
        <div className="co-sheet-handle" />
        <div className="co-sheet-head">
          <div className="co-sheet-title">Review Photos</div>
          <div className="co-sheet-badge">{photos.length} photo{photos.length !== 1 ? 's' : ''}</div>
        </div>

        <div className="co-sheet-body">
          <div className="pc-photo-grid">
            {photos.map((p, i) => (
              <div key={i} className="pc-photo-thumb" onClick={() => onPhotoTap(i)}>
                <img src={p} alt={`Photo ${i + 1}`} />
                <button
                  className="pc-photo-del"
                  onClick={e => { e.stopPropagation(); onDeletePhoto(i); }}
                >
                  <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
          <div className="pc-review-hint">Tap to preview full size</div>
          <button className="co-btn-ghost" onClick={onAddMore}>+ Add more photos</button>
        </div>

        <div className="co-sheet-actions">
          <button className="co-btn-sage" onClick={onContinue}>Continue to Notes →</button>
        </div>
      </div>
    </CaptureOverlay>
  );
};
